var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMaritime = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M18.1 11.5c-.3 0-.5-.2-.5-.5V7c0-.1-.1-.2-.2-.2H8.2c-.1 0-.1.1-.1.2v4c0 .3-.2.5-.5.5s-.5-.3-.5-.5V7c0-.7.5-1.2 1.2-1.2h9.2c.7 0 1.2.5 1.2 1.2v4c-.1.2-.3.5-.6.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M15.1 6.8c-.3 0-.5-.2-.5-.5V3.7H11v2.6c0 .3-.2.5-.5.5s-.5-.2-.5-.5V3.7c0-.5.4-1 .8-1h4c.5 0 .8.4.8 1v2.6c0 .3-.2.5-.5.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M16.5 21.2c-.1 0-.2 0-.2-.1-.2-.1-.3-.4-.2-.7l2.7-5.3c.1-.2.4-.3.7-.2.2.1.3.4.2.7L17 20.9c-.1.2-.3.3-.5.3"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M8.4 21.2c-.2 0-.4-.1-.5-.3L4.6 12 12 9c.5-.2 1.1-.2 1.6.1l3.1 1.1 4.8 1.9-2.1 4.2c-.1.2-.4.3-.7.2-.2-.1-.3-.4-.2-.7l1.6-3.2-3.7-1.5-3.1-1.2c-.3-.1-.6-.2-.8-.1l-6.6 2.6 3 8q.15.45-.3.6c-.1.2-.2.2-.2.2"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M12.8 15.7c-.3 0-.5-.2-.5-.5V9.3c0-.3.2-.5.5-.5s.5.2.5.5v5.9c0 .3-.2.5-.5.5"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M15.3 23.3c-1 0-2.2-.3-3.4-1-2.8-1.8-5.6.6-5.8.7-.2.2-.5.1-.7-.1s-.1-.5.1-.7c0 0 3.6-2.9 6.9-.8 3.6 2.3 6.7-.6 6.8-.7.2-.2.5-.2.7 0s.2.5 0 .7c0 0-2 1.9-4.6 1.9"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M15.4 14c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1 1.1.5 1.1 1.1c-.1.7-.5 1.1-1.1 1.1m0-1.4q-.3 0-.3.3t.3.3c.3 0 .3-.1.3-.3 0-.1-.2-.3-.3-.3"
})));
export default SvgMaritime;